/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./conversationList.scss');

const deps = [
  require('data/date').name,
  require('data/collection/conversationSummary').name,
  require('data/collection/conversation').name,
  require('ui/web/conversationBrief').name,
];

module.exports = angular
  .module('bench.ui.conversationList', deps)

  .directive('blConversationList', () => ({
    restrict: 'E',
    scope: {
      onSelect: '&',
      attachedTo: '=',
      clientId: '=',
      activeConversationId: '=',
    },
    bindToController: true,
    template: require('./conversationList.html'),
    controller: require('./conversationListCtrl.js'),
    controllerAs: 'vm',
  }));
